export enum LabelDividerPositionEnum {
    center = 'center',
    left = 'left',
    right = 'right'
}
